import { Auth } from "aws-amplify";
import uuidv4 from "uuid/v4";

import * as actionTypes from "../actionTypes";
import syncAll from "../../../utils/syncAll";
import { updateServiceProviderUser } from "../../../utils/appsyncOperations";
import { bugsnagClient } from "../../..";

export const _onSignOutSuccess = () => ({ type: actionTypes.app.RESET });
export const _onAuthSuccess = (user) => ({
  type: actionTypes.auth.AUTH_SUCCESS,
  user: {
    username: user.username,
    attributes: user.attributes,
  },
});
export const _onAuthError = (error) => ({
  type: actionTypes.auth.AUTH_ERROR,
  error,
});
export const _authLoading = () => ({ type: actionTypes.auth.AUTH_LOADING });
export const _authNewPassword = (user) => ({
  type: actionTypes.auth.AUTH_NEW_PASSWORD,
  user,
});

export const signOut = () => async (dispatch, getState) => {
  dispatch(_authLoading());
  try {
    const user = getState().auth.user;
    await updateServiceProviderUser({
      serviceProviderId: user.attributes["custom:service_provider_id"],
      userId: user.username,
      status: "OFFLINE",
      idempotentKey: uuidv4(),
    });
    await Auth.signOut();
    localStorage.clear();
    dispatch(_onSignOutSuccess());
  } catch (error) {
    dispatch(
      _onAuthError(error.message ? error.message : "An unknown error occurred.")
    );
  }
};

export const attemptAuth = () => async (dispatch, getState) => {
  dispatch(_authLoading());
  try {
    const user = await Auth.currentAuthenticatedUser();
    bugsnagClient.user = {
      email: user.username,
    };
    await syncAll(user.attributes["custom:service_provider_id"]);
    dispatch(_onAuthSuccess(user));
  } catch (error) {
    dispatch(
      _onAuthError(error.message ? error.message : "An unknown error occurred.")
    );
  }
};

export const lib = {
  attemptAuth,
};
